import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Select } from '@raro/ui';
import { api } from '../lib/api';
import { useBrands } from '../lib/brands';

/**
 * A marca de uma fonte que não está em projeto (fonte do cadastro do cliente). Só aparece em cliente com mais de uma marca.
 * Fonte dentro de projeto segue a marca do projeto e não se mexe por aqui.
 */
export function SourceBrand({ sourceId, organizationId, brandId, canEdit }: { sourceId: string; organizationId: string; brandId: string | null; canEdit: boolean }) {
  const qc = useQueryClient();
  const { brands, multi } = useBrands(organizationId);
  const move = useMutation({ mutationFn: (value: string) => api.patch(`/sources/${sourceId}`, { brandId: value === 'grupo' ? null : value }), onSuccess: () => { void qc.invalidateQueries({ queryKey: ['source'] }); } });
  if (!multi) return null;
  return (
    <Select value={brandId ?? 'grupo'} onChange={(e) => move.mutate(e.target.value)} disabled={!canEdit || move.isPending} aria-label="marca da fonte" title="de qual marca é este material" style={{ width: 'auto' }}>
      {brands.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
      <option value="grupo">do grupo (todas as marcas)</option>
    </Select>
  );
}
